import { ICustomerFullInfoContext } from './customerFullInfoContext';

export enum CustomerFullInfoActionTypes {
	SET_CUSTOMER_FOR_FULL_INFO = 'SET_CUSTOMER_FOR_FULL_INFO',
	CHANGE_CUSTOMER_FULL_INFO_VISIBLE_FORM = 'CHANGE_CUSTOMER_FULL_INFO_VISIBLE_FORM',
	SET_LOCALIZATION_GROUP = 'SET_LOCALIZATION_GROUP',
	SET_LOCALIZATION_LANGUAGE = 'SET_LOCALIZATION_LANGUAGE',
	SET_LOCALIZATION_DATA = 'SET_LOCALIZATION_DATA',
	SET_STYLE_DATA = 'SET_STYLE_DATA',
	SET_STYLE_GROUP = 'SET_STYLE_GROUP',
	SET_STYLE_LANGUAGE = 'SET_STYLE_LANGUAGE',
	SET_LATEST_SOFTWARE_UPDATE_DATA = 'SET_LATEST_SOFTWARE_UPDATE_DATA',
	SET_BPA_DATA = 'SET_BPA_DATA',
}

interface IChangeCustomerFullInfoVisibleForm {
	type: CustomerFullInfoActionTypes.CHANGE_CUSTOMER_FULL_INFO_VISIBLE_FORM;
	payload: {
		customerFullInfoVisibleForm: ICustomerFullInfoContext['customerFullInfoVisibleForm'];
	};
}

interface ISetCustomerForFullInfo {
	type: CustomerFullInfoActionTypes.SET_CUSTOMER_FOR_FULL_INFO;
	payload: {
		customerForFullInfo: ICustomerFullInfoContext['customerForFullInfo'];
	};
}

interface ISetLocalizationGroup {
	type: CustomerFullInfoActionTypes.SET_LOCALIZATION_GROUP;
	payload: {
		selectedLocalizationGroup: ICustomerFullInfoContext['selectedLocalizationGroup'];
	};
}

interface ISetLocalizationLanguage {
	type: CustomerFullInfoActionTypes.SET_LOCALIZATION_LANGUAGE;
	payload: {
		selectedLocalizationLanguage: ICustomerFullInfoContext['selectedLocalizationLanguage'];
	};
}

interface ISetLocalizationData {
	type: CustomerFullInfoActionTypes.SET_LOCALIZATION_DATA;
	payload: {
		localizationData: ICustomerFullInfoContext['localizationData'];
	};
}

interface ISetStyleData {
	type: CustomerFullInfoActionTypes.SET_STYLE_DATA;
	payload: {
		styleData: ICustomerFullInfoContext['styleData'];
	};
}

interface ISetStyleGroup {
	type: CustomerFullInfoActionTypes.SET_STYLE_GROUP;
	payload: {
		selectedStyleGroup: ICustomerFullInfoContext['selectedStyleGroup'];
	};
}

interface ISetStyleLanguage {
	type: CustomerFullInfoActionTypes.SET_STYLE_LANGUAGE;
	payload: {
		selectedStyleLanguage: ICustomerFullInfoContext['selectedStyleLanguage'];
	};
}

interface ISetLatestSoftwareUpdateData {
	type: CustomerFullInfoActionTypes.SET_LATEST_SOFTWARE_UPDATE_DATA;
	payload: {
		latestSoftwareUpdateData: ICustomerFullInfoContext['latestSoftwareUpdateData'];
	};
}

interface ISetPbaData {
	type: CustomerFullInfoActionTypes.SET_BPA_DATA;
	payload: {
		bpaData: ICustomerFullInfoContext['bpaData'];
	};
}

export type TCustomerFullInfoAction =
	| IChangeCustomerFullInfoVisibleForm
	| ISetCustomerForFullInfo
	| ISetLocalizationGroup
	| ISetLocalizationLanguage
	| ISetLocalizationData
	| ISetStyleData
	| ISetStyleGroup
	| ISetStyleLanguage
	| ISetLatestSoftwareUpdateData
	| ISetPbaData;
